import moment from 'moment';
import {
  NODE_TYPES,
  VALUE_PROPOSITION_NODE_ID,
  DELAYED_COLOR,
  TO_START_COLOR,
  DEFINITION_COLOR,
  IN_PROGRESS_COLOR,
  FUNCTIONAL_COLOR,
  FINISHED_COLOR,
  CRITICAL_WEEK_COLOR,
  BLACK,
  WHITE,
  STARTUP_SECTIONS_ARRAY,
} from './constants';

const nodeTypesArray = () => Object.values(NODE_TYPES);

const nodeId = (type, id) => {
  if (nodeTypesArray().includes(type)) {
    switch (type) {
      case NODE_TYPES.VALUE_PROPOSITION:
        return VALUE_PROPOSITION_NODE_ID;
      default:
        return `${type}-${id}`;
    }
  }
  return null;
};

const getBorderColor = (status) => {
  switch (status) {
    case 'in_progress':
      return IN_PROGRESS_COLOR;
    case 'definition':
      return DEFINITION_COLOR;
    case 'functional':
      return FUNCTIONAL_COLOR;
    case 'finished':
      return FINISHED_COLOR;
    case 'critical_week':
      return CRITICAL_WEEK_COLOR;
    case 'delayed':
      return DELAYED_COLOR;
    default:
      return TO_START_COLOR;
  }
};

const getBackgroundColor = (status) => {
  switch (status) {
    case 'in_progress':
      return WHITE;
    case 'functional':
      return WHITE;
    case 'delayed':
      return WHITE;
    case 'finished':
      return FINISHED_COLOR;
    default:
      return WHITE;
  }
};

const safeMomentDate = (date) => {
  const result = moment(date);
  if (result.isValid()) {
    return result;
  }
  return undefined;
};

export {
  nodeId, getBorderColor, getBackgroundColor, safeMomentDate,
};
